import React from "../../__compat__/react/main.entry.mjs.mjs";
import { useSpacing } from "../../api/spacing/useSpacing.mjs.mjs";
import { pickComponentCommonProps } from "../../interfaces/commonProps.mjs.mjs";
import { StyledContainer, StyledButtonGroup } from "./ButtonGroup.styles.mjs.mjs";
export const ButtonGroup = React.forwardRef(({ block = false, children, variant, ...restProps }, ref) => {
    return (React.createElement(StyledContainer, { outerSpacing: useSpacing(restProps), ref: ref, ...pickComponentCommonProps(restProps) },
        React.createElement(StyledButtonGroup, { variant: variant, block: block }, children)));
});
ButtonGroup.displayName = 'ButtonGroup';
//# sourceMappingURL=ButtonGroup.mjs.mjs.map